/*
 Copyright (c), CKSource Holding sp. z o.o. All rights reserved.
 */

import PackageDataMessage, { IPackageDataMessage } from './packagedatamessage';
import { IDescriptorBody } from '../../../descriptor';

import ParserUtils, { MessageDataTypes } from './../parserutils';

export interface IStringStringPacketDataMessage extends IPackageDataMessage {
	data: string;
	data1: string;
}

export default class StringStringPacketDataMessage extends PackageDataMessage {
	public static readonly TYPE: number =
		/* #__PURE__ -- @preserve */ ( () => ParserUtils.getPacketType( MessageDataTypes.STRING, MessageDataTypes.STRING ) )();

	public static readonly DESCRIPTOR_NAME: string = 'StringStringPacketDataMessage';

	public static readonly DESCRIPTOR: IDescriptorBody = /* #__PURE__ -- @preserve */ ( () => ( {
		fields: {
			data: {
				type: 'string',
				id: 1
			},
			data1: {
				type: 'string',
				id: 2
			}
		}
	} ) )();

	public constructor( public readonly data: string, public readonly data1: string ) {
		super();
	}

	public toJSON(): IStringStringPacketDataMessage {
		return {
			data: this.data,
			data1: this.data1
		};
	}

	public static fromJSON( data: IStringStringPacketDataMessage ): StringStringPacketDataMessage {
		return new StringStringPacketDataMessage( data.data, data.data1 );
	}

	public static create( data: string, data1: string ): StringStringPacketDataMessage {
		return new StringStringPacketDataMessage( data, data1 );
	}
}
